import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=784f4a64"
import script from "./Agregar.vue?vue&type=script&lang=js"
export * from "./Agregar.vue?vue&type=script&lang=js"
import style0 from "./Agregar.vue?vue&type=style&index=0&id=784f4a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports